import React from "react";

const ArrowUpIcon = () => {
    return (
        <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector 147" d="M6.48047 13.7783L6.48047 0.740768M6.48047 0.740768L11.9631 6.22342M6.48047 0.740768L0.992672 6.22856" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default ArrowUpIcon;